import "core-js/internals/inspect-source";
import "core-js/actual/array/to-sorted";
import "core-js/actual/array/to-reversed";
import "core-js/actual/array/to-spliced";
import "core-js/actual/array/with";
import "web-streams-polyfill/polyfill/es5";
import { TextDecoder as TextDecoderPolyfill } from "@bacons/text-decoder";
import structuredClone from "@ungap/structured-clone";
import "@azure/core-asynciterator-polyfill";
import "core-js/actual/url";
import "core-js/actual/url-search-params";
import { promiseWithResolvers } from "./utils/promiseWithResolvers";
import { installFetch } from "./platform/fetch";
import { installCrypto } from "./platform/crypto";
var _globalThis;
var _TextDecoder;
var _globalThis1;
var _structuredClone;
var _globalThis2;
var _requestAnimationFrame;
globalThis["global"] = globalThis;
(_globalThis = globalThis)[_TextDecoder = "TextDecoder"] || (_globalThis[_TextDecoder] = TextDecoderPolyfill);
(_globalThis1 = globalThis)[_structuredClone = "structuredClone"] || (_globalThis1[_structuredClone] = structuredClone);
(_globalThis2 = globalThis)[_requestAnimationFrame = "requestAnimationFrame"] || (_globalThis2[_requestAnimationFrame] = setTimeout);
Promise.withResolvers || (Promise.withResolvers = promiseWithResolvers);
installFetch();
installCrypto();
//# sourceMappingURL=polyfills-mobile.js.map
